import { configureStore } from "@reduxjs/toolkit";
import userReducer from './user'
import infoReducer from './info'

export default configureStore({
    reducer: {
        user: userReducer,
        info: infoReducer
    }
}) 